<template>
  <div class="transition-all">
    <div
      :class="[drawerWidth == '18rem' ? 'show fade' : 'invisible']"
      class="end-drawer__overlay fixed top-0 end-0 z-[1020] opacity-50 bg-gray-500 dark:bg-slate-800 backdrop-blur-md w-full h-full"
      @click="onOverlayClick"
    ></div>
    <div
      :style="{
        width: drawerWidth
      }"
      class="end-drawer__container z-[1024] absolute inset-0 top-0 end-0 start-auto h-full shadow-xl bg-white transition-all ease-in-out"
    >
      <div v-if="globalStore.endbarState" class="absolute top-4 end-4">
        <button
          class="absolute top-0 end-0"
          @click="globalStore.$patch((state) => (state.endbarState = false))"
        >
          <faTimesIcon class="w-4 fill-white" />
        </button>
      </div>
      <div class="flex flex-col gap-y-2 h-full overflow-y-auto">
        <slot>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
          <div class="w-full aspect-video bg-teal-100"></div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@/stores/global'
import faTimesIcon from '@/assets/icons/faTimes.svg?component'

const globalStore = useGlobalStore()

const drawerWidth = ref(0)

globalStore.$subscribe((mutation, { endbarState: sidebarState }) => {
  drawerWidth.value = sidebarState ? '18rem' : 0

  document.body.style.overflow = globalStore.hasDrawer ? 'hidden' : 'inherit'
})

const onOverlayClick = () => {
  globalStore.$patch({ endbarState: false })
}
</script>

<style lang="scss" scoped></style>
